Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var DEFAULT_ENVIRONMENT = 'production';
exports.DEFAULT_ENVIRONMENT = DEFAULT_ENVIRONMENT;